// This is a map between company and project views.
// To be used when user switches mode, and select what
// view redirect to.

export const COMPANY_TO_PR_ROUTE = {
    "constructibles_manager": "constructibles",
    "company_production_files": "production_files",
    "company_management_files": "management_files",
    // The list: a report detail needs the report, which belongs to one project.
    "company_production_file_detail": "production_files",
    "company_management_file_detail": "management_files",
    "production_overview": "project_overview",
    "parts_list": "project_parts_list",
    "parts_list_detail": "project_parts_list_detail",
    "part_batches": "project_part_batches",
    "part_batches_detail": "project_part_batches_detail",
    "company_issues": "issues",
    // The list: the project route needs a project the issue may not be in.
    "company_issues_detail": "issues",
}


export const PR_TO_COMPANY_ROUTE = {

    "viewer": "company_settings",
    "assd_viewer": "company_settings",
    "ass_viewer": "company_settings",
    "modd_viewer": "company_settings",
    "project_viewer": "company_settings",

    "panels": "company_settings",
    "panel_detail": "company_settings",
    "files": "company_settings",
    "designs": "company_settings",
    "design_detail": "company_settings",
    "project_overview": "production_overview",
    "issues": "company_issues",
    "issue_detail": "company_issues",
    "quantities": "company_settings",
    "production_files": "company_production_files",
    "management_files": "company_management_files",
    "production_file_detail": "company_production_files",
    "management_file_detail": "company_management_files",
    "constructibles": "constructibles_manager",
    "project_parts_list": "parts_list",
    "project_parts_list_detail": "parts_list_detail",
    "project_part_batches": "part_batches",
    // The list, not the detail: this direction pushes the route name with no
    // params, and the company detail route requires the batch uuid.
    "project_part_batches_detail": "part_batches",
}

export const VIEWER_ROUTES = [
    "viewer",
    "assd_viewer",
    "ass_viewer",
    "modd_viewer",
    "mod_viewer",
    "project_viewer",
]

export const MISC_ROUTES = [
    "qr",
    "account",
]

export const NO_REDIRECT_ROUTES = [
    ...VIEWER_ROUTES,
    ...MISC_ROUTES,
    undefined,
]